import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
    generateReportPdf(_, queryParams = '') {
        return axios.post(`${serverUrl}/reports/generate_pdf/`, queryParams, queryParams.type)
    }
}